<template>
    <v-card>
        <v-card-title>
            <h2>{{stats.division}} Standings</h2>
        </v-card-title>
        <v-card-text>
            <v-layout pb-3>
                <v-flex xs3 text-xs-center>
                    <span class="title">{{stats.place}}</span>
                    <br />
                    <span class="subheading">Place</span>
                </v-flex>
                <v-flex xs3 text-xs-center>
                    <span class="title">{{stats.weeks}}</span>
                    <br />
                    <span class="subheading">Weeks Played</span>
                </v-flex>
                <v-flex xs3 text-xs-center>
                    <span class="title">{{stats.wins}}</span>
                    <br />
                    <span class="subheading">Wins</span>
                </v-flex>
                <v-flex xs3 text-xs-center>
                    <span class="title">{{stats.cashes}}</span>
                    <br />
                    <span class="subheading">Cashes</span>
                </v-flex>
            </v-layout>
            <v-divider ></v-divider>
            <v-layout pt-3>
                <v-flex xs4 text-xs-center>
                    <span class="title">{{stats.points}}</span>
                    <br />
                    <span class="subheading">Points</span>
                    <div class="caption pt-2">{{stats.points_max}} Max</div>
                    <div class="caption">{{stats.points_avg | decimal}} Avg</div>
                    <div class="caption">{{stats.points_min}} Min</div>
                </v-flex>
                <v-flex xs4 text-xs-center>
                    <span class="title">{{stats.strokes}}</span>
                    <br />
                    <span class="subheading">Strokes</span>
                    <div class="caption pt-2">{{stats.strokes_max}} Max</div>
                    <div class="caption">{{stats.strokes_avg | decimal}} Avg</div>
                    <div class="caption">{{stats.strokes_min}} Min</div>
                </v-flex>
                <v-flex xs4 text-xs-center>
                    <span class="title">{{stats.from_par}}</span>
                    <br />
                    <span class="subheading">Par</span>
                    <div class="caption pt-2">{{stats.from_par_max}} Max</div>
                    <div class="caption">{{stats.from_par_avg | decimal}} Avg</div>
                    <div class="caption">{{stats.from_par_min}} Min</div>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
  export default {
    name: 'DivisionSummary',
    props: ['stats']
  }
</script>

<style scoped>

</style>
